import { BannerContent } from '@urc-ui/components/feature-intro-banner/types';

export enum SUBSCRIPTION_STATUS {
  ACTIVE = 'ACTIVE',
  PAUSED = 'PAUSED',
  EXPIRED = 'EXPIRED',
  INVALID = 'INVALID',
  FAILED = 'FAILED'
}

export enum SUBSCRIPTION_FREQUENCY {
  SINGLE = 'SINGLE',
  DAILY = 'DAILY',
  WEEKLY = 'WEEKLY',
  MONTHLY_DATE = 'MONTHLY_DATE'
}
export type SubscriptionFrequency = keyof typeof SUBSCRIPTION_FREQUENCY;

export enum DAYS_IN_WEEK {
  MONDAY = 'MONDAY',
  TUESDAY = 'TUESDAY',
  WEDNESDAY = 'WEDNESDAY',
  THURSDAY = 'THURSDAY',
  FRIDAY = 'FRIDAY',
  SATURDAY = 'SATURDAY',
  SUNDAY = 'SUNDAY'
}

export enum SUBSCRIPTION_TYPE {
  NOW = 'NOW',
  FUTURE = 'FUTURE',
  RECURRING = 'RECURRING'
}
export type SubscriptionType = keyof typeof SUBSCRIPTION_TYPE;

export enum REPORT_CATEGORY {
  SP = 'sp',
  HSA = 'hsa',
  SB = 'sb',
  SBV = 'sbv',
  SD = 'sd',
  ST = 'st',
  PDA = 'pda',
  PDA_LEGACY = 'pda_legacy',
  AA = 'aa',
  ADSP = 'adsp',
  ALL = 'all'
}

export enum PRESET_PERIOD {
  TODAY = 'TODAY',
  YESTERDAY = 'YESTERDAY',
  LAST_7_DAYS = 'LAST_7_DAYS',
  THIS_WEEK = 'THIS_WEEK',
  WEEK_TO_DATE = 'WEEK_TO_DATE',
  LAST_WEEK = 'LAST_WEEK',
  LAST_14_DAYS = 'LAST_14_DAYS',
  THIS_MONTH = 'THIS_MONTH',
  MONTH_TO_DATE = 'MONTH_TO_DATE',
  LAST_30_DAYS = 'LAST_30_DAYS',
  LAST_MONTH = 'LAST_MONTH',
  CUSTOM = 'CUSTOM'
}

export const REPORT_PERIOD_ALIAS: Record<string, string> = {
  [PRESET_PERIOD.THIS_MONTH]: PRESET_PERIOD.MONTH_TO_DATE,
  [PRESET_PERIOD.THIS_WEEK]: PRESET_PERIOD.WEEK_TO_DATE
};

export enum TIME_UNIT {
  HOUR = 'HOUR',
  DAY = 'DAY',
  WEEK = 'WEEK',
  MONTH = 'MONTH',
  QUARTER = 'QUARTER',
  SUMMARY = 'SUMMARY'
}

export enum REPORT_STATUS {
  COMPLETED = 'COMPLETED',
  PENDING = 'PENDING',
  PROCESSING = 'PROCESSING',
  FAILED = 'FAILED',
  CANCELED = 'CANCELED',
  DELETED = 'DELETED'
}

export enum ERROR_TYPE {
  TOO_MANY_REQUESTS = 'TOO_MANY_REQUESTS',
  UNAUTHORIZED = 'UNAUTHORIZED'
}

export enum REPORT_NAME_VALIDATION_ERROR_TYPE {
  NO_ERROR = 'NO_ERROR',
  ERROR_MISSING_REPORT_NAME = 'ERROR_MISSING_REPORT_NAME',
  ERROR_REPORT_NAME_TOO_LONG = 'ERROR_REPORT_NAME_TOO_LONG',
  ERROR_INVALID_CHARACTERS = 'ERROR_INVALID_CHARACTERS'
}

export enum FILTER_TYPES {
  GLOBAL_FILTER_TYPE = 'marketplaceIds',
  CAMPAIGN_SITE_FILTER_TYPE = 'campaignSite',
  MRC_ACCREDITATION_STATUS = 'mrcAccreditationStatus'
}

export enum MTA_CHECKBOX_STATUS {
  ENABLED = 'true',
  DISABLED = 'false'
}

export enum FEATURE_INTRO_WIDGET_ID {
  BENCHMARKS_REPORT = 'amazon-benchmarks-report-feature-intro-banner'
}

export const FEATURE_INTRO_BANNER_CONTENTS: Record<string, BannerContent> = {
  [FEATURE_INTRO_WIDGET_ID.BENCHMARKS_REPORT]: {
    body: 'sspa_rcm_ad_reports_benchmarks_feature_banner_text'
  }
};

export enum MRC_CHECKBOX_STATUS {
  ENABLED = 'true',
  DISABLED = 'false'
}
